import * as React from 'react';
import UserContext from '../../context/UserContext/UserContext';
import BotStatus from './BotStatus/BotStatus';
import UserDropdown from './UserDropdown/UserDropdown';

function Header(): React.ReactElement {
  const { user } = React.useContext(UserContext);
  const isAuthenticated = user?.mfaComplete;

  return (
    <header className='flex items-center justify-between w-full h-16 bg-[#012438] shadow-none px-6 py-4'>
      {isAuthenticated && (
        <div className='flex items-center justify-between w-full'>
          <BotStatus />
          <UserDropdown />
        </div>
      )}
    </header>
  );
}

export default Header;
